// ============================================================
//  ZBCC Custom Case Builder — Main Logic
//  EDIT THE 3 LINES BELOW BEFORE UPLOADING TO SHOPIFY ASSETS
// ============================================================
var ZBCC_CLOUD_NAME    = 'dlbdfjotd';      // your Cloudinary cloud name
var ZBCC_UPLOAD_PRESET = 'ZBCC_Cases';   // your unsigned upload preset
var ZBCC_PRODUCT       = 'custom-product';    // your Shopify product handle

// ============================================================
//  DO NOT EDIT BELOW THIS LINE
// ============================================================
document.addEventListener('DOMContentLoaded', function () {

  var state = {
    imageURL:   null,
    caseType:   'Glass Case',  // fixed — only glass cases available
    phoneModel: null,
    variantId:  null,
    uploading:  false
  };

  var MODEL_SERIES = {
    'iPhone 17 Pro Max':17,'iPhone 17 Pro':17,'iPhone 17 Air':17,'iPhone 17':17,
    'iPhone 16 Pro Max':16,'iPhone 16 Pro':16,'iPhone 16 Plus':16,'iPhone 16':16,
    'iPhone 15 Pro Max':15,'iPhone 15 Pro':15,'iPhone 15 Plus':15,'iPhone 15':15,
    'iPhone 14 Pro Max':14,'iPhone 14 Pro':14,'iPhone 14 Plus':14,'iPhone 14':14,
    'iPhone 13 Pro Max':13,'iPhone 13 Pro':13,'iPhone 13 Mini':13,'iPhone 13':13,
    'iPhone 12 Pro Max':12,'iPhone 12 Pro':12,'iPhone 12 Mini':12,'iPhone 12':12,
    'iPhone 11 Pro Max':11,'iPhone 11 Pro':11,'iPhone 11':11
  };

  var CASE_COMPAT = {
    'Glass Case': { min:11, max:17 }
  };

  // ---- Fetch variant on load ----
  fetch('/products/' + ZBCC_PRODUCT + '.js')
    .then(function(r){ return r.json(); })
    .then(function(p){
      // Always use first variant — inventory is managed in Shopify settings
      if(p.variants && p.variants.length) {
        state.variantId = p.variants[0].id;
        console.log('[ZBCC] Variant loaded:', state.variantId);
      }
    })
    .catch(function(){ console.warn('[ZBCC] Could not load product: ' + ZBCC_PRODUCT); });

  // ---- Phone SVG ----
  // Render default phone on load (zbccRenderPhone defined in zbcc-phones.js)
  if (typeof zbccRenderPhone === 'function') zbccRenderPhone(null);

  // ---- UI state ----
  function updateUI() {
    var s1=!!state.imageURL, s3=!!state.phoneModel;
    [1,3,4].forEach(function(n){ var el=q('[data-step="'+n+'"]'); if(el) el.classList.remove('active','done'); });
    var _e1=q('[data-step="1"]'); if(_e1){ if(s1) _e1.classList.add('done'); else _e1.classList.add('active'); }
    if(s3){ var _e3=q('[data-step="3"]'); if(_e3) _e3.classList.add('done'); } else if(s1){ var _e3b=q('[data-step="3"]'); if(_e3b) _e3b.classList.add('active'); }
    if(s1&&s3){ var _e4=q('[data-step="4"]'); if(_e4) _e4.classList.add('active'); }
    setBlock('upload',s1); setBlock('model',s3);
    var btn=q('#zbcc-atc-btn');
    if(btn) btn.disabled = !(s1&&s3&&!state.uploading);
  }

  function setBlock(name, done) {
    var el=q('#zbcc-block-'+name);
    if(!el) return;
    el.classList.toggle('done', done);
    el.classList.toggle('active', !done);
  }

  function q(sel){ return document.querySelector(sel); }

  // ---- File upload ----
  var fileInput  = q('#zbcc-file-input');
  var uploadZone = q('#zbcc-upload-zone');

  if(fileInput) fileInput.addEventListener('change', function(e){
    if(e.target.files && e.target.files[0]) handleFile(e.target.files[0]);
  });
  if(uploadZone){
    uploadZone.addEventListener('dragover',  function(e){ e.preventDefault(); uploadZone.classList.add('dragover'); });
    uploadZone.addEventListener('dragleave', function(){ uploadZone.classList.remove('dragover'); });
    uploadZone.addEventListener('drop', function(e){
      e.preventDefault(); uploadZone.classList.remove('dragover');
      if(e.dataTransfer.files && e.dataTransfer.files[0]) handleFile(e.dataTransfer.files[0]);
    });
  }

  function handleFile(file) {
    var allowed = ['image/png','image/jpeg','image/webp','image/heic'];
    if(!allowed.includes(file.type) && !/\.(png|jpe?g|webp|heic)$/i.test(file.name)){
      setValidation('Please upload a PNG, JPG, or WEBP image.'); return;
    }
    if(file.size > 25*1024*1024){ setValidation('File too large. Max 25MB.'); return; }
    var reader = new FileReader();
    reader.onload = function(ev) {
      showPreview(ev.target.result);
      doUpload(file, ev.target.result);
    };
    reader.readAsDataURL(file);
  }

  function showPreview(src) {
    var img = q('#zbcc-preview-img');
    var ph  = q('#zbcc-placeholder');
    if(!img) return;
    img.src = src;
    img.classList.add('visible');
    if(ph) ph.style.display = 'none';
  }

  function doUpload(file, localURL) {
    if(!ZBCC_CLOUD_NAME || ZBCC_CLOUD_NAME === 'YOUR_CLOUD_NAME') {
      state.imageURL = localURL;
      onUploadDone(); return;
    }
    state.uploading = true;
    var prog = q('#zbcc-upload-progress');
    var bar  = q('#zbcc-progress-bar');
    var txt  = q('#zbcc-progress-text');
    if(prog) prog.classList.add('visible');

    var fd = new FormData();
    fd.append('file', file);
    fd.append('upload_preset', ZBCC_UPLOAD_PRESET);

    var xhr = new XMLHttpRequest();
    xhr.open('POST','https://api.cloudinary.com/v1_1/'+ZBCC_CLOUD_NAME+'/image/upload');
    xhr.upload.onprogress = function(e){
      if(e.lengthComputable && bar){
        var p = Math.round(e.loaded/e.total*100);
        bar.style.width = p+'%';
        if(txt) txt.textContent = 'Uploading '+p+'%...';
      }
    };
    xhr.onload = function(){
      state.uploading = false;
      if(prog) prog.classList.remove('visible');
      if(xhr.status===200){
        state.imageURL = JSON.parse(xhr.responseText).secure_url;
        onUploadDone();
      } else {
        setValidation('Upload failed — please try again.');
        updateUI();
      }
    };
    xhr.onerror = function(){
      state.uploading = false;
      if(prog) prog.classList.remove('visible');
      state.imageURL = localURL;
      onUploadDone();
    };
    xhr.send(fd);
  }

  function onUploadDone() {
    var zone  = q('#zbcc-upload-zone');
    var icon  = q('#zbcc-upload-icon');
    var title = q('#zbcc-upload-title');
    var sub   = q('#zbcc-upload-sub');
    var status= q('#zbcc-upload-status');
    if(zone)   zone.classList.add('has-file');
    if(icon)   icon.textContent  = '✅';
    if(title)  title.textContent = 'Design uploaded!';
    if(sub)    sub.textContent   = 'Tap to change image';
    if(status) status.textContent= '✓ Done';
    updateUI();
  }

  // drag to reposition (zoom/rotate/pinch-zoom controls removed)
  (function(){
    var wrap = q('#zbcc-design-wrap');
    var img  = q('#zbcc-preview-img');
    if(!wrap || !img) return;

    var drag=false, ox=0, oy=0, sx=0, sy=0;
    function dragStart(e){
      if(!img.classList.contains('visible')) return;
      if(e.touches && e.touches.length > 1) return;
      drag=true;
      var t=e.touches?e.touches[0]:e;
      sx=t.clientX-ox; sy=t.clientY-oy;
      img.style.cursor='grabbing';
      e.preventDefault();
    }
    function dragMove(e){
      if(!drag) return;
      if(e.touches && e.touches.length > 1) { drag=false; return; }
      var t=e.touches?e.touches[0]:e;
      ox=t.clientX-sx; oy=t.clientY-sy;
      img.style.marginLeft=ox+'px'; img.style.marginTop=oy+'px';
      e.preventDefault();
    }
    function dragEnd(){ drag=false; img.style.cursor='grab'; }

    wrap.addEventListener('mousedown',  dragStart);
    wrap.addEventListener('touchstart', dragStart, {passive:false});
    document.addEventListener('mousemove', dragMove);
    document.addEventListener('touchmove', dragMove, {passive:false});
    document.addEventListener('mouseup',   dragEnd);
    document.addEventListener('touchend',  dragEnd);
  })();

  // ---- Case type ----
  // Case type fixed to Glass Case — zbccSelectCase not needed

  function filterModels() {
    // All models 11-17 available for Glass Case — nothing to disable
  }

  // ---- Phone model ----
  window.zbccSelectModel = function(el) {
    var val=el.value; if(!val) return;
    if(state.caseType){
      var c=CASE_COMPAT[state.caseType];
      if(MODEL_SERIES[val]<c.min||MODEL_SERIES[val]>c.max){
        el.value='';
        setValidation(val+' is not available for '+state.caseType+'. Please pick another model or case type.');
        return;
      }
    }
    state.phoneModel=val;
    var ms=q('#zbcc-model-status'); if(ms) ms.textContent='✓ '+val;
    var note=q('#zbcc-series-note');
    if(note) note.innerHTML = '';
    if (typeof zbccRenderPhone === "function") zbccRenderPhone(val);
    clearValidation();
    updateUI();
  };

  // ---- Add to cart ----
  window.zbccAddToCart = function() {
    clearValidation();
    if(!state.imageURL)   { setValidation('Please upload your design first.'); return; }
    if(!state.caseType)   { setValidation('Please select a case type.'); return; }
    if(!state.phoneModel) { setValidation('Please select your phone model.'); return; }
    if(state.uploading)   { setValidation('Please wait for upload to finish.'); return; }
    if(!state.variantId){
      setValidation('Loading product...');
      fetch('/products/'+ZBCC_PRODUCT+'.js')
        .then(function(r){ return r.json(); })
        .then(function(p){
          if(p.variants && p.variants.length){
            state.variantId = p.variants[0].id;
            clearValidation(); doAddToCart();
          } else { setValidation('Product has no variants. Check your Shopify product.'); }
        })
        .catch(function(){ setValidation('Cannot load product "'+ZBCC_PRODUCT+'". Check the handle in zbcc-main.js.'); });
      return;
    }
    doAddToCart();
  };

  function doAddToCart() {
    var btn=q('#zbcc-atc-btn');
    if(btn){ btn.classList.add('loading'); btn.disabled=true; }
    fetch('/cart/add.js',{
      method:'POST',
      headers:{'Content-Type':'application/json','Accept':'application/json'},
      body:JSON.stringify({
        id: parseInt(state.variantId),
        quantity: 1,
        properties: {
          'Phone Model':    state.phoneModel,
          'Case Type':      state.caseType,
          '_Custom Design': state.imageURL,
          '_preview':       state.imageURL
        }
      })
    })
    .then(function(res){
      if(!res.ok) return res.json().then(function(e){ throw new Error(e.description||'Cart error'); });
      return res.json();
    })
    .then(function(){
      if(btn){ btn.classList.remove('loading'); btn.disabled=false; }
      showToast('Your custom case is in the cart!');
      fetch('/cart.js').then(function(r){return r.json();}).then(function(cart){
        document.querySelectorAll('.cart-count,.cart__count,[data-cart-count],.header__cart-count').forEach(function(el){ el.textContent=cart.item_count; });
      });
      setTimeout(function(){ window.location.href='/cart'; }, 900);
    })
    .catch(function(err){
      if(btn){ btn.classList.remove('loading'); btn.disabled=false; }
      setValidation('Could not add to cart: '+(err.message||'Please try again.'));
    });
  }

  // ---- Toast ----
  function showToast(msg) {
    var t=q('#zbcc-toast');
    var m=q('#zbcc-toast-msg');
    if(!t) return;
    if(m) m.textContent=msg;
    t.classList.add('visible');
    setTimeout(function(){ t.classList.remove('visible'); }, 3500);
  }

  // ---- Validation ----
  function setValidation(msg)  { var el=q('#zbcc-validation'); if(el) el.textContent=msg; }
  function clearValidation()   { var el=q('#zbcc-validation'); if(el) el.textContent='';  }

});